<template>
    <div class="my-select">
        <a-select v-bind="$attrs"
                  v-on="$listeners"
                  v-model="$attrs.value"
                  :options="selectData"
                  :filterOption="() => true"
                  @search="search"
                  @popupScroll="popupScroll"
                  ref="mySelect" style="width: 100%;">
        </a-select>
    </div>
</template>

<script>
export default {
    data() {
        return {
            originalData: [],
            selectData: [],
            searchData: [],
            selectSize: 20,
            timer: null,
            searchValue: "",
        }
    },
    props: {
        options: Array
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    watch: {
        "options"(now) {
            this.initData(now);
        },
        "$attrs.value"(now) {
            if (this.originalData.length) {
                this.initValue();
            }
        }
    },
    created() {
        this.initData(this.options);
    },
    methods: {
        initData(data) {
            const replace = this.$attrs.replaceFields || {};
            let label = "label", value = "value";
            if (replace.label) {
                label = replace.label;
            }
            if (replace.value) {
                value = replace.value;
            }
            this.originalData = [];
            for (let i = 0; i < data.length; i++) {
                this.originalData.push({
                    label: data[i][label],
                    value: data[i][value],
                    index: i,
                    ...data[i]
                })
            }
            this.initValue();
        },
        initValue() {
            this.selectData = [];
            if (!this.$attrs.value) {
                for (let i = 0; i < this.selectSize; i++) {
                    if (this.originalData[i]) {
                        this.selectData.push(this.originalData[i]);
                    }
                }
                return
            }
            for (let i = 0; i < this.originalData.length; i++) {
                if (this.originalData[i].value === this.$attrs.value) {
                    let start = i - this.selectSize / 2, end = i + this.selectSize / 2;
                    if (end > this.originalData.length) {
                        end = this.originalData.length;
                        start = start - (i + this.selectSize - this.originalData.length);
                    }
                    if (start <= 0) {
                        start = 0;
                    }
                    while (start < end) {
                        this.selectData.push(this.originalData[start++])
                    }
                    break
                }
            }
        },
        limit(type) {
            let start = 0, end = 0;
            if (this.searchData.length) {
                if (this.selectData.length) {
                    start = this.selectData[this.selectData.length - 1].searchIndex + 1;
                }
                end = start + this.selectSize;
                if (end > this.searchData.length) {
                    end = this.searchData.length;
                }
                for (let i = start; i < end; i++) {
                    this.selectData.push(this.searchData[i]);
                }
                return
            }
            if (type === "push") {
                if (this.selectData.length) {
                    start = this.selectData[this.selectData.length - 1].index + 1;
                }
                end = start + this.selectSize;
                if (end > this.originalData.length) {
                    end = this.originalData.length;
                }
                for (let i = start; i < end; i++) {
                    this.selectData.push(this.originalData[i]);
                }
            } else {
                end = this.selectData[0].index - 1;
                start = end - this.selectSize;
                if (start <= 0) {
                    start = 0;
                }
                for (let i = end; i >= start; i--) {
                    this.selectData.unshift(this.originalData[i]);
                }
            }
        },
        popupScroll(e) {
            if (e.target.scrollTop + e.target.offsetHeight > e.target.lastChild.offsetTop + e.target.lastChild.offsetHeight - 200) {
                this.limit("push");
            }
            if (e.target.scrollTop < e.target.offsetHeight) {
                if (!this.searchData.length) {
                    this.limit("unshift");
                }
            }
        },
        search(val) {
            this.searchValue = val;
            if (!this.timer) {
                this.timer = setTimeout(() => {
                    this.timer = null;
                    this.searchData = [];
                    this.selectData = [];
                    if (!this.searchValue) {
                        this.limit("push");
                        return
                    }
                    let label = "label", index = 0;
                    if (this.$attrs.optionFilterProp) {
                        label = this.$attrs.optionFilterProp;
                    }
                    for (let i = 0; i < this.originalData.length; i++) {
                        if (this.originalData[i][label].indexOf(this.searchValue) > -1) {
                            this.searchData.push({
                                searchIndex: index++,
                                ...this.originalData[i]
                            });
                        }
                    }
                    this.limit()
                }, 300)
            }
        }
    }
}
</script>

<style scoped>
.my-select {
    min-width: 120px;
}
</style>